<style lang="scss" scoped>
.create-classroom {
	&__delete {
		text-align: right;
	}
}
.el-card {
	.formContent {
		padding: 20px;
	}
}
.avatarContainer + /deep/ .el-form-item__error {
	margin-top: -1px;
}
</style>

<template lang="pug">
    component(:is="modalDisplay ? 'layout-modal' : 'el-card'").create-classroom.no-padding
        el-form(:label-position="modalDisplay ? 'left' : 'top'", label-width='160px', :rules='rules', :model='classroom', ref="form")
            .formContent
                el-form-item(label='Name', prop="name")
                    el-input(v-model="classroom.name")
                el-form-item(label='Description', prop="description")
                    el-input(type="textarea", :autosize="{ minRows: 3, maxRows: 4}", v-model="classroom.description")
                el-form-item(label="Select icon", prop="Icon")
                    avatar-selector(v-model="classroom.Icon").avatarContainer
            .el-card__footer(v-if="!modalDisplay")
                el-button(type="text", :loading="loading", native-type="submit", @click.prevent="submit") Save classroom
                portal(v-if="showDeleteButton", to="header-bar-actions")
                    el-button(type="danger", @click="deleteClassroom", :loading="deleteLoading") Delete classroom
        template(v-if="modalDisplay", slot="footer")
            el-row(:gutter="20")
                el-col(:span="12")
                    el-button(type="primary", :loading="loading", native-type="submit", @click.prevent="submit") Save classroom
                    el-button(@click="$vuedals.close()") Cancel
                el-col(:span="12", v-if="this.classroom && this.classroom.id && this.User.is_teacher").create-classroom__delete
                    el-button(type="danger", @click="deleteClassroom", :loading="deleteLoading") Delete classroom
</template>

<script>
import { pick, reject } from "lodash";
import gql from "graphql-tag";
import AvatarSelector from "@/components/classroom/create/AvatarSelector";

export default {
	components: {
		AvatarSelector
	},
	props: {
		showDeleteButton: {
			type: Boolean,
			default: false
		},
		modalDisplay: {
			type: Boolean,
			default: false
		},
		classroom: {
			type: Object,
			default: () => ({
				name: null,
				description: null,
				Icon: {
					type: null,
					value: null
				}
			})
		},
		navigateAfter: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			loading: false,
			deleteLoading: false,
			rules: {
				name: [
					{ required: true, message: "Classroom name is required", trigger: "blur", type: "string", whitespace: true },
					{
						min: 2,
						message: "Name must be atleast 2 characters long",
						trigger: "blur"
					},
					{
						max: 50,
						message: "Name must be less than 100 characters long",
						trigger: "blur"
					}
				],
				Icon: [
					{
						validator: (rule, { value }, callback) => {
							if (!value) {
								return callback(new Error("Please select an icon"));
							}

							return callback();
						},
						trigger: "blur"
					}
				],
				description: [
					{ max: 200, message: "Maximum description length is 200 characters", trigger: "blur" },
					{ type: "string", whitespace: true, message: "Description invalid" }
				]
			}
		};
	},
	apollo: {
		User: {
			query: gql`
				query getUser($classUuid: String!) {
					User {
						id
						is_teacher
						is_free_teacher
					}
				}
			`
		}
	},
	methods: {
		async deleteClassroom() {
			this.deleteLoading = true;

			try {
				await this.$confirm("Are you sure you want to delete this classroom?", "Warning", {
					confirmButtonText: "Yes I'm sure",
					cancelButtonText: "Cancel"
				});

				await this.$apollo.mutate({
					mutation: gql`
						mutation DeleteClassroom($uuid: String!) {
							DeleteClassroom(uuid: $uuid)
						}
					`,
					variables: {
						uuid: this.classroom.id
					},
					update: store => {
						const QUERY = gql`
							{
								User {
									id
									Classrooms {
										id
									}
								}
							}
						`;
						const data = store.readQuery({
							query: QUERY
						});

						// Add our tag from the mutation to the end
						data.User.Classrooms = reject(data.User.Classrooms, { id: this.classroom.id });
						store.writeQuery({ query: QUERY, data });
					}
				});
				this.$vuedals.close();
				this.$message.success("Classroom deleted");

				this.$router.push({ name: "dashboard" });
			} catch (error) {
				console.log("error", error);
			}

			this.deleteLoading = false;
		},
		async submit() {
			this.loading = true;

			try {
				await this.$refs.form.validate();

				try {
					await this.$apollo.mutate({
						mutation: gql`
							mutation SaveClassroom($input: SaveClassroomInput!, $uuid: String) {
								SaveClassroom(input: $input, uuid: $uuid) {
									id
									name
									description
									Icon {
										type
										value
									}
								}
							}
						`,
						update: (store, resultData) => {
							if (!this.classroom || !this.classroom.id) {
								const QUERY = gql`
									{
										User {
											id
											Classrooms {
												id
												name
												description
												Icon {
													type
													value
												}
											}
										}
									}
								`;
								const data = store.readQuery({
									query: QUERY
								});

								// Add our tag from the mutation to the end
								data.User.Classrooms.push(resultData.data.SaveClassroom);
								// Write our data back to the cache.
								store.writeQuery({ query: QUERY, data });

								this.$emit("save", resultData.data.SaveClassroom);
							}
						},
						variables: {
							input: {
								...pick(this.classroom, ["name", "description"]),
								icon: pick(this.classroom.Icon, ["type", "value"])
							},
							uuid: this.classroom && this.classroom.id ? this.classroom.id : null
						}
					});
				} catch (error) {
					console.log("error", error);

					if (this.classroom) {
						this.$message.error("Failed to update classroom");
					} else {
						this.$message.error("Failed to create classroom");
					}

					return;
				}

				if (this.classroom) {
					this.$message.success("Classroom updated");
				} else {
					this.$message.success("Classroom created");
				}
				// Closess this modal
				this.$vuedals.close();

				// Closes the introduction modal if it's open
				this.$vuedals.close({
					$index(data, vuedals) {
						return vuedals.findIndex(modal => (modal.title = "Create classroom"));
					}
				});
			} catch (error) {
				console.error("error", error);
			}

			this.loading = false;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/classroom/CreateOrEdit.vue